<template>
	<div class="maxMaxth home-scrollbar menPensmeConems me3Dian7"   >
		<advertisementHome v-if="popList.length" @CancelDisplay="CancelDisplay"
			:popList="popList" :isShow="isCancelDisplay"></advertisementHome>
		<sidebars :sidebarsList="sidebarsList"> </sidebars>
		<sidebarsLeft :sidebarsList="sidebarsLeftList"></sidebarsLeft>
		<SanDianLiu></SanDianLiu>
		<div class="conterTeng-scrollbar"
		ref="homeScrollbar"
		@scroll="handleScroll"
		:style="{
			height:`calc(100vh - ${$store.state.xiazApp?.9+.7:.9}rem)`
		}">
			<Swipe :swipeList="banner"></Swipe>
			<!-- icon-sprite_icon_xx_2yj--svgSprite:all -->
			<div class="notice-barCome">
				<div class="notice-bar"  :style="{
					'width':'7.1rem',
					'background-image':`url(${aqhzf5lmse})`
				}" >
					<div class="mengLisnMens" >
						<div style="position: relative;width: .3rem;height: .3rem;color: var(--theme-text-color-lighten);margin-right: .2rem;margin-left: .2rem;">
							<svg-icon class="svg-icon_pmd mt2" style="width: .3rem;height: .3rem;font-size: .32rem;" icon-class="icon_dt_2pmd--svgSprite:all" />
						</div>
						<van-notice-bar class="marquee" style="height: 20px;color: var(--skin__lead);font-weight: 700;" :left-icon="tongzhi" :scrollable="true">
							<div style="display: flex;align-items: center;">
								<div v-for="(item,index) in marquee" @click="openUrl('notice',{active:3,marqueeIndex:index}) " v-html="item"></div>
							</div>
						</van-notice-bar>
						<div style="position: relative;width: .4rem;height: .35rem;color: var(--theme-text-color-lighten);margin-right: .2rem;">
							<!-- icon-sprite_icon_xx_1yj--svgSprite:all -->
							<svg-icon class="svg-icon_pmd mt2" style="width: .4rem;height: .35rem;font-size: .24rem;" icon-class="icon_xx_1yj--svgSprite:all" />
						</div>
					</div>
				</div>
			</div>

			<div class="zhtDEqmqr6aOwFvu_UTp" v-if="$store.state.config.show_jackpot">
        <div
          class="_VQdc8vOEOzzyOEUKmvZ"
          :style="`background-position: 0px 0px;background-image: url(${config.jackpot_image});background-size: 100% 100%;`"
        >
          <CountTo
            :startVal="startVal"
            @getDisplayValue="getDisplayValue"
            :endVal="BonusAmount"
            :decimals="2"
            :duration="5000"
          />
          <div
            slot="defaultValue"
            class="defaultValue"
            style="
              margin-top: 0.4rem;
              display: flex;
              align-items: center;
              --jackpot-card-count-box-scale: 0.6;
              transform: scale(var(--jackpot-card-count-box-scale));
            "
          >
            <span
              v-for="(char, index) in getBonusChars(BonusTrendsAmount)"
              :key="index"
              :class="`sprite-font sprite-char-${char}`"
              :style="getSpriteStyle(char)"
              style="display: inline-block; height: 0.83rem"
            >
            </span>
          </div>
        </div>
      </div>
			
			<div class="notice-barCome warp-wYU5E"  v-if="!vuex_token_head">
				<div class="warp-notlogin-azGf5">
					<div class=""  @click="$store.commit('isRecord'),$store.commit('publicFun',['isRecordType',1])">
						<span>LOGIN</span>
					</div>
					<div class="" @click="$store.commit('isRecord'),$store.commit('publicFun',['isRecordType',0])">
						<span>REGISTRO</span>
					</div>
				</div>
			</div>
			<!-- --theme-mine-icon-color -->
			<div class="" v-else>
				<div class="_user-info-box_mk765_17">
					<div class="_user-top_mk765_23" @click="copyContent(userInfo.user_name)">
						<div class="_vip-badge-box_10qr0_17" style="background: linear-gradient(rgb(255, 88, 31), rgb(232, 1, 0));">
							<img class="lobby-image lobby-image _img_10qr0_26" :src="a27ljH635n" alt=".">
							<span class="_level_10qr0_32" :data-text="userInfo.vip_info.level">{{userInfo.vip_info.level}}</span>
						</div>
						<span class="_title_mk765_29">Conta</span>
						<span class="_platform-id_mk765_32">{{userInfo.user_name}}</span>
						<svg-icon @click="copyContent(userInfo.user_name)" style="width: .18rem;height: .18rem;font-size: .24rem;color: var(--skin__alt_lead);" icon-class="comm_icon_Mens_copy--svgSprite:all" />
					</div>
					<div class="countTextBox global-currency-info-index" @click="animate">
						<!-- <i class="yj5rHjAv0U7RlHMzWr7F img skeleton-box" :style="{
							backgroundImage:`url(${_coloImg})`
						}" style="display: inline-block; position: relative; width: 0.3rem; height: 0.3rem;background-position: -7.15714rem -2.79643rem; background-size: 7.77857rem 7.59107rem;"></i> -->
						<svg-icon class="xuanzhuan" icon-class="style_5_icon_btm_cz--svgSprite:all" />
						<span class="notranslate">{{userBalance}}</span>
						<svg-icon class="xuanzhuan" icon-class="comm_icon_sx--svgSprite:all" />
					</div>
				</div>
				<div class="warp-wYU5E notice-barCome" v-if="false">
					<div class="warp-wYU5EComes">
						<div>
							<div style="display: flex;align-items: center;">
								<span class="warp-card-user-login-wrap-vip-BttMM">VIP {{userInfo.vip_info.level}}</span>
								<div class="me-infoname" @click="copyContent(userInfo.user_name)" >
									<i>{{userInfo.user_name}} </i>
									<svg-icon style="width: 0.28rem; height: 0.28rem;margin-left: .02rem;" className="imageWrap" icon-class="style_1_icon_copy--svgSprite:all" />
								</div>
							</div>
							<div class="countTextBox" @click="animate">
								<svg-icon class="xuanzhuan" icon-class="style_5_icon_btm_cz--svgSprite:all" />
								<!-- <i class="yj5rHjAv0U7RlHMzWr7F img skeleton-box" :style="{
									backgroundImage:`url(${_coloImg})`
								}" style="display: inline-block; position: relative; width: 0.3rem; height: 0.3rem;background-position: -7.15714rem -2.79643rem; background-size: 7.77857rem 7.59107rem;"></i> -->
								<span class="notranslate">{{userBalance}}</span>
								<svg-icon class="xuanzhuan" icon-class="comm_icon_sx--svgSprite:all" />
							</div>
						</div>
						<!-- #icon-sprite_ -->
						<div class="SaqueDepósito">
							<div @click="$store.commit('isDeposit',true)">
								<svg-icon class="xuanzhuan" icon-class="icon-mes" classNameQita />
								<p>{{ $t('mine._Depósito') }}</p>
							</div>
							<div @click="openUrl(userInfo.set_withdraw_password?'withdraw':'security')">
								<svg-icon class="xuanzhuan" icon-class="icon-nem-sems-a" classNameQita />
								<p>{{ $t('mine._Saque') }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="_hk-activities-promotion_d9i85_17" v-if="$store.state.config.home_invite">
				<div class="_activities-promotion-box_d9i85_24" :style="{'background-image':`url(${a1xtdTu85p})`}">
					<div class="_box-left_d9i85_34" :style="{'background-image':`url(${alhcdZpr55})`}"></div>
					<!-- alhcdZpr55 -->

					<div class="_box-center_d9i85_40" style="padding-top: .05rem;">
						<h3 class="_title_d9i85_49"><span>{{$t('_home._Convideumpacote')}}</span></h3>
						<div><div class="_count-msg_d9i85_71"><p>{{$t('promote._Total')}}:{{homeBonusInfo.total}} </p><p>{{$t("_home._Distnciaw")}}:{{homeBonusInfo.distance}}</p>
						<p>{{$t('_home._Recebido')}}:{{homeBonusInfo.received}}</p><p>{{$t('_home._Montantefixo')}}:{{homeBonusInfo.total_recharge}}</p></div></div>
					</div>
					<div class="_box-right_d9i85_95" :style="{'background-image':`url(${asicdR6ihj})`}">
						<p class="_recived-amount_d9i85_108">{{homeBonusInfo.recent_bonus}}</p>
						<div class="_promote-count-bg_d9i85_127" :style="{'background-image':`url(${idu8wBah1n})`}">
							<p>{{$t('_home._Convidar')}}  {{homeBonusInfo.recent_num}} {{$t('_home._jogador')}} </p>
						</div>
					</div>

				</div>
			</div>

			<div class="conter_box"
			 :class="{
				 isTabsShow:isTabsShow,
			 }"
			 style="padding-bottom:1rem">
				<div class="tebConTenet">
					<!-- comm_icon_meUnefh--svgSprite -->
					<p @click="scrollLeftRight('left')"><svg-icon class="RbbrBFJf" icon-class="comm_icon_meUnefh--svgSprite:all" /></p>
					<div class="tebConListConem" ref="tebScroll">
						<div class="tebConList" @click="tabFun(index)" :class="iconListIndex==index?'active':''" v-for="(item,index) in iconList">
							<img class="img" :src="item.svg" alt="" />
							<p>{{$t('popup')[item.textName]}}</p>
							<img class="btn_zc1_jr2" v-if="config.festival_img.button_2 != '#'" :src="config.festival_img.button_2" alt="" />
						</div>
					</div>
					<p @click="scrollLeftRight('right')"><svg-icon :style="{
						'transform': 'rotate(180deg)'
					}" class="RbbrBFJf" icon-class="comm_icon_meUnefh--svgSprite:all" /></p>
				</div>
				<div v-if="iconListIndex==0">
					<div class="_tabs_14rgh_17">
						<div class="_left_14rgh_28">
							<div class="_headerItem_14rgh_35 _active_14rgh_62">
								<img class="_headerIcon_14rgh_57" :src="ap8pjEqbxr" alt="" />
								<div class="_name_14rgh_53">Popular</div>
							</div>
							<div class="_headerItem_14rgh_35 " @click="onClickDisabled('recent')">
								<svg-icon  style="width: .35rem;height: .35rem;font-size: .24rem;" icon-class="hBkf9vyL-icon_dtfl_zj_0:all" />
								<div class="_name_14rgh_53">Recente</div>
							</div>
							<div class="_headerItem_14rgh_35" @click="onClickDisabled('favorite')">
								<svg-icon  style="width: .35rem;height: .35rem;font-size: .24rem;" icon-class="rNuA70NJ-icon_dtfl_sc_0:all" />
								<div class="_name_14rgh_53">Favoritos</div>
							</div>
						</div>
						<div  @click="$router.push({name:'search'})" style="flex-grow: 1;padding-right: .12rem;display: flex;">
							<img :src="ace5uUz4su" style="width: .55rem;height: auto;" alt="" sizes="" srcset="" />
						</div>
					</div>
				</div>
				<div class="vwuYKuCNAmUF0GsyJhVu">
					<div class="gameItemBox" v-if="iconList[iconListIndex].name && tabNav  && tabNav[iconList[iconListIndex].name]">
						<gameItem v-for="(item_a,index_1) in tabNav[iconList[iconListIndex].name].list" :category="iconList[iconListIndex].name"
							:item="item_a" type="home" :key="index_1"></gameItem>
						<div style="display: flex;justify-content: center;width: 100%;">
							<van-empty v-if="!tabNav[iconList[iconListIndex].name].list.length" image-size="106px" class="custom-image"
								:image="img_none_sj" :description="$t('_Nenhumjogodisponvel')" />
						</div>
					</div>
				</div>


				<div class="LseXQWJMvDiV2XalL3sA">
					<div class="bUGFPYZ0IBtUg6TvqFnc vertival-box">
						<div class="UJY0E549iXw8BAops2og item-box">
							<div class="JxE2bCrlce_jVHNQ56UL link-list-title">{{$t('components._CanalOficial')}}</div>
							<div class="dIvaBEC9yHdlaEHxlYwe" style="display: flex;">
								<img :src="ConemUel" @click="goToNewPage($store.state.config.telegram)"  style="width: .7rem;height: .7rem;margin-right: .2rem;" alt="">
								<img :src="ConemUel" @click="goToNewPage($store.state.config.instagram)" style="width: .7rem;height: .7rem;margin-right: .2rem;" alt="">
								<img :src="ConemUel" @click="goToNewPage($store.state.config.online_service)" style="width: .7rem;height: .7rem;margin-right: .2rem;" alt="">
							</div>
						</div>

					</div>
					<!--  -->
					<div class="company-info">
						<p v-html="$store.state.config.explain_description"></p>
					</div>

					<div v-if="$store.state.config.ui_type == 'mk'" class="company-info2" style="padding-top: .3rem;">
						<p><strong>{{$('_home._CASSINO')}} </strong> {{$('_home._entertainment')}}<strong>{{$('_home._NovaWave')}}</strong>, {{$('_home._Caribbeaundern')}}</p>
						<p>.{{$('_home._accessingBy')}}</p>
					</div>
					<!--  -->

					<!--  -->
					<div class="ZvyDsn48oSuCoga63jmJ copy-right">
						<div class="ZvyDsn48oSuCoga63jmJ" style="padding-bottom: .1rem;    font-size: .18rem;text-align: center;">
							<ul>
								<li style="width: 50%;">
									<p class="">
									<p style="font-size: .18rem;">{{$store.state.config.project_name}}</p>
									</p>
								</li>
								<li style="width: 50%;">
									<p style="font-size: .18rem;" v-html="$store.state.config.copyright"></p>
								</li>

							</ul>
						</div>
					</div>
				</div>
				<!--  -->
			</div>

			<!-- <Overlay></Overlay> -->
			<Sidebar></Sidebar>

		</div>

	</div>


</template>

<script>
// @ is an alias to /src
import Sidebar from '@/components/sidebar/index.vue';
import Swipe from '@/components/swipe/index.vue';
import {
  ICON_NAV3Dian7,
  ICON_NAVActive
} from '@/assets/public/icon_nav.js';
import gameItem from '@/components/gameItem/index3.7.vue';
import CountTo from '@/components/vue-count-to/vue-countTo.vue';
import advertisementHome from '@/components/advertisement/home.vue';
import sidebars from '@/components/sidebars/index.vue';
import SanDianLiu from '@/components/header/index3.7.vue';
import sidebarsLeft from '@/components/sidebars/index-left.vue';

import {
  mapState
} from 'vuex';
let time;
import Vue from 'vue';
import {
  baseConfig,
  popAndBanner,
  notification,
  jackpot,
  getAllGameCategory,
  getDataByGameCategory,
  homeBonus
} from '@/apis/modules/home.js';
export default {
  name: 'Home',
  components: {
	sidebarsLeft,
    Sidebar,
    Swipe,
    sidebars,
    CountTo,
    gameItem,
    advertisementHome,
    SanDianLiu
  },
  computed: {
    ...mapState(['first_recharge','active','popList','tabNav','banner','sidebarsList','sidebarsLeftList','marquee','config','isCancelDisplay','vuex_token_head','userInfo','moneyInfo'])
  },
  data() {
    return {
      ConemUel:require('./../../assets/4Ddian/1891317513356587009.jpg'),
      aqhzf5lmse: require('./../../assets/4Ddian/aqhzf-5lmse.png'),
      a1xtdTu85p: require('./../../assets/4Ddian/a1xtd-tu85p.png'),
      alhcdZpr55: require('./../../assets/4Ddian/alhcd-zpr55.png'),
      asicdR6ihj: require('./../../assets/4Ddian/asicd-r6ihj.png'),
      idu8wBah1n: require('./../../assets/4Ddian/idu8w-bah1n.png'),
      ap8pjEqbxr: require('./../../assets/4Ddian/ap8pj-eqbxr.png'),
      ace5uUz4su: require('./../../assets/4Ddian/ace5u-uz4su.png'),
      a27ljH635n: require('./../../assets/4Ddian/a27lj-h635n.png'),
      // a27lj-h635n.png
      tongzhi: require('./../../assets/icons/images/icon_dt_pmd.png'),
      coloImgactivity: require('./../../assets/icons/images/1795312712372871170.gif'),
      startVal: 0,
      iconList: [],
      iconListIndex:0,
      stateActive:true,
      widUrl:window.location.href,
      activeList: ICON_NAVActive,
      base_Config: {},
      BonusAmount: '',
      BonusTrendsAmount: '',
      recentJson:{},
      favoriteJson:{},
      thisiTime:'',
      tabState: false,
      vuex_tokenIs: false,
      scrollDom:'',
      isTabsShow:false,
      tabForm:{
        leftRight:0
      },
      userBalance: '0,00',
      homeBonusInfo:{
        total:0,
        distance:0,
        received:'0,00',
        total_recharge:'0,00',
        recent_bonus:'0,00',
        recent_num:0
      },
			// 精灵图字符映射
      spriteCharMap: {
        0: { x: 0, y: 0, width: 0.5 },
        1: { x: -0.5, y: 0, width: 0.5 },
        2: { x: -1.05, y: 0, width: 0.5 },
        3: { x: -1.52, y: 0, width: 0.5 },
        4: { x: -2.05, y: 0, width: 0.5 },
        5: { x: -2.55, y: 0, width: 0.5 },
        6: { x: -3.05, y: 0, width: 0.5 },
        7: { x: -3.55, y: 0, width: 0.5 },
        8: { x: -4.08, y: 0, width: 0.5 },
        9: { x: -4.55, y: 0, width: 0.5 },
        '.': { x: -5.05, y: 0, width: 0.3 },
        ',': { x: -5.35, y: 0, width: 0.3 }
      },
    };
  },
  created() {
    this.inviteFun();
    if (this._vuex_token && typeof this._vuex_token() == 'string') {
      this.getBalance();
      this.vuex_tokenIs = true;
      this.iconList = ICON_NAV3Dian7.filter((item, index) => {
        return item.textName != '_Demo';
      });
    } else {
      this.iconList = ICON_NAV3Dian7;
    }
    this.getpopAndBanner();
    this.getNotification();
    this.getAllGameCategory();
    this.showRegisterPage();
  },
  mounted() {
    Vue.prototype.homeScrollbarDom = this.$refs.homeScrollbar;
    this.$nextTick(() => {
			  let el=this.$refs.navTbaSwConte.$el;
			  let scrollDom=el.getElementsByClassName('van-tabs__nav--complete')[0];
			  this.scrollDom=scrollDom;
			  let offsetWidth=scrollDom.offsetWidth;
			  let scrollWidth= scrollDom.scrollWidth;
			  let scrollJisuan=scrollWidth-offsetWidth;
			  let {leftRight}=this.tabForm;
			  scrollDom.addEventListener('scroll', (e)=>{
				  if(scrollJisuan<=scrollDom.scrollLeft){
					  this.tabForm.leftRight=1;
				  }else if(scrollDom.scrollLeft==0){
					  this.tabForm.leftRight=0;
				  }else if(leftRight!=2 && scrollDom.scrollLeft!=0){
					  this.tabForm.leftRight=2;
				  }
			  });
    });
    this.getjackpot(0);
    this.showBalance();
    this.gethomeBonus();
  },
  watch: {
    moneyInfo: {
      handler(val) {
        this.showBalance();
      },
      deep: true
    },
    active:{
      handler(val) {
        this.tabFun(val,'',true);
        // this.showBalance();
      },
      deep: true
    }
  },
  beforeDestroy() {
    clearTimeout(this.thisiTime);
  },
  methods: {
    async gethomeBonus(){
      if(!this.vuex_tokenIs)return;
      let {data}=await homeBonus({});
      this.homeBonusInfo=data;
    },
    showBalance() {
      this.userBalance = this.$store.state.config.balance_no_bonus.includes('home') ? this.moneyInfo.balance_coin_str : this.moneyInfo.balance_total_str;
    },
    scrollLeftRight(e){
      if(e=='left'){
        this.$refs.tebScroll.scrollLeft=0;
      }else if(e=='right'){
        this.$refs.tebScroll.scrollLeft=Date.now();
      }
      // this.$refs.tebScroll.scrollRight=Date.now();
    },
		// 精灵图字体相关方法
    getBonusChars(amount) {
      // 将数字转换为字符数组
      return String(amount || '0').split('');
    },
    getSpriteStyle(char) {
      const pos = this.spriteCharMap[char];
      if (pos) {
        return {
          backgroundPosition: `${pos.x}rem ${pos.y}rem`,
          width: `${pos.width}rem`,
          backgroundImage: `url(${require('@/assets/cjc1_style_' +
            this.$store.state.config.jackpot_number_img +
            '_font_sprite.webp')})`,
          backgroundSize: 'auto 100%',
          backgroundRepeat: 'no-repeat'
        };
      }
      return {
        backgroundImage: `url(${require('@/assets/cjc1_style_6_font_sprite.webp')})`,
        backgroundSize: 'auto 100%',
        backgroundRepeat: 'no-repeat',
        width: '0.5rem'
      };
    },
    CancelDisplay(e){
      this.$store.commit('publicFun',['isCancelDisplay',false]);
      if(this.$store.state.isRefreshLoading){
        setTimeout(()=>{
          let isRechargeGiftTime=localStorage.getItem('isRechargeGiftTime');
          let isRechargeGift=localStorage.getItem('isRechargeGift');
          if(isRechargeGiftTime && isRechargeGift!=='false'){
            if(isRechargeGiftTime<new Date().getTime()){
              this.$store.commit('publicFun',['isCancelDisplay',true]);
            }
          }
          if(!isRechargeGift&& !isRechargeGiftTime){
            if(this.first_recharge.status=='show'){
              this.$store.commit('publicFun',['isRechargeGift',true]);
            }
          }
        },500);
        this.$store.commit('publicFun',['isRefreshLoading',false]);
      }
    },
    showRegisterPage() {
      if(this.vuex_tokenIs || !this.$store.state.config.register_page_pop)return;
      this.$store.commit('isRecord');
      this.$store.commit('publicFun',['isRecordType',0]);
    },
    inviteFun(){
      let {id,type}=this.$route.query;
      //console.log(this.$route.query,id,type,'inviteID 22')
      if(id){
        window.localStorage.setItem('inviteID',id);
      }
      // this.$store.commit('isRecord')
      // this.$store.commit('publicFun',['isRecordType',0])
    },
    navTbaSw(e){
      if(e=='right'){
        this.scrollDom.scrollLeft=1000;
      }
      if(e=='left'){
        this.scrollDom.scrollLeft=0;
      }
    },
    beforeChange(name,title){//

    },
    scrollTabs(e) {
    },
    handleScroll(e) {
      clearTimeout(time);
      time = setTimeout(() => {
        clearTimeout(time);
        if (e.target.scrollTop > (e.target.offsetHeight/3+59)) {
          this.$store.commit('publicFun', ['Returntotop', true]);
        } else if (this.$store.state.Returntotop) {
          this.$store.commit('publicFun', ['Returntotop', false]);
        }
        if(e.target.scrollTop>(e.target.scrollHeight-e.target.offsetHeight-20)){
          this.isTabsShow=true;
        }else{
          this.isTabsShow=false;
        }
      }, 10);
    },
    isDisabled(index) {
      let isTrue = false;
      let active = this.$store.state.active;
      if (index == 3) {
        isTrue = true;
        return true;
      }
      if (active < 3) {
        if (index < 3) {
          return false;
        }
        if (index > 3) {
          isTrue = false;
          return true;
        }
      }
      if (active > 3) {
        if (index < 3) {
          isTrue = true;
          return true;
        }
        if (index > 3) {
          isTrue = false;
          return false;
        }
      }
      return isTrue;
    },
    getAllGameCategory() {
      if(this.tabNav.popular){
        return false;
      }
      getAllGameCategory({}).then(({
        code,
        data = {},
        msg
      }) => {
        this.$store.commit('publicFun', ['tabNav', data]);
      });
    },
    goToNewPage(url) {
      if (url == '#') {
        return false;
      }
      window.open(url, '_blank');
    },
    congxJiazai(category,_key_) {
      let pageSize = category == 'popular' && this.$store.state.config.popular_page_size ? this.$store.state.config.popular_page_size : 6;
      let page=this.tabNav[category] ? this.tabNav[category].now/pageSize+1 : 1;
      //console.log(_key_)
      if(_key_){page=this[_key_+'Json'].now ? this[_key_+'Json'].now/pageSize+1 : 1;}
      getDataByGameCategory({
        category: category,
        page: page
      }).then(({
        code,
        data = {},
        msg
      }) => {
        if(!_key_){
          this.tabNav[category] ={
            ...this.tabNav[category],
            now: data.now,
            list: [...this.tabNav[category].list, ...data.list]
          };
          this.$store.commit('publicFun', ['tabNav',this.tabNav]);
        }else{
          let listz=(this[_key_+'Json'].list?[...this[_key_+'Json'].list, ...data.list]:[...data.list]);
          this[_key_+'Json']={
            ...this[_key_+'Json'],
            now:data.now,
            list:listz
          };
        }

      });
    },
    getDisplayValue(value) {
      this.BonusTrendsAmount = value;
    },
    getpopAndBanner() { //
      if(this.banner.length){
        return false;
      }
      popAndBanner({}).then(({
        code,
        data = {},
        msg
      }) => {
        let {
          banner,
          pop,
          sidebars,
          first_recharge
        } = data;
        this.$store.commit('publicFun', ['banner', banner]);
        this.$store.commit('publicFun', ['first_recharge', first_recharge]);
        // this.banner = banner;
        if (!this.popList.length) {
          this.$store.commit('popList', pop.map((item) => {
            return {
              ...item,
              isShow: true
            };
          }));
        }
        this.$store.commit('publicFun', ['sidebarsList', sidebars.right.map((item) => {
					return {...item,isShow: true};
        })]);
				this.$store.commit('publicFun', ['sidebarsLeftList', sidebars.left.map((item) => {
          return {...item,isShow: true};
        })]);
      });
    },

    getNotification() {
      if(this.marquee){
        return false;
      }
      notification({}).then(({
        code,
        data,
        msg
      }) => { //404
        let {
          marquee
        } = data;
        this.$store.commit('publicFun', ['marquee', marquee]);
      });
    },
    getjackpot(tim,_false) {
      if (!this.$store.state.config.show_jackpot)return;
      // if(_false){return false}
      clearTimeout(this.thisiTime);
      this.thisiTime = setTimeout(() => {

        jackpot({
          isLOgin: true
        }).then(({
          code,
          data,
          msg
        }) => {
          this.startVal=data-1999||0;
          this.BonusAmount = data || 0;
        });
        if(this.$route.name=='home'){
          this.getjackpot(10000);
        }
        let {code,category}=this.$route.query;
      }, tim);
    },
    onClickDisabled(e) {
      this.$router.push({
        name: 'subgame',
        query: {
          id: '',
          category: e||'demo'
        }
      });
    },
    openUrlMenssearch(e){
      this.$router.push({
        name: 'search',
        query: {
          tabActive: e
        }
      });
    },
    tabFun(e,title) {
      this.iconListIndex=e;
      let category=this.iconList[e].name;
      if(category=='demo'){
        this.onClickDisabled();
      }
      if(category=='recent'){
        this.$router.push({
          name: 'search',
          query: {
            id: '',
            tabActive: 2
          }
        });
      }
      if(category=='favorite'){
        this.$router.push({
          name: 'search',
          query: {
            id: '',
            tabActive: 3
          }
        });
      }
      if(!_true){
        this.$store.commit('active', e);
      }
    },
    stickyScroLL(e) {}
  }
};
</script>
<style scoped>
	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 {
	    position: relative;
	    display: flex
	;
	    align-items: center;
	    justify-content: space-between;
	    width: 100%;
	    height: 2.32rem;
	    background-size: contain;
	    background-repeat: no-repeat;
	}
	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 ._box-right_d9i85_95 {
	    background-size: cover;
	    background-repeat: no-repeat;
	    width: 1.62rem;
	    height: 1.46rem;
	    position: relative;
	    display: flex;
	    align-items: center;
	    justify-content: flex-start;
	    flex-direction: column;
	    margin-bottom: .58rem;
	    margin-right: .1rem
	}
	._hk-activities-promotion_d9i85_17{
		    margin-top: .15rem;
	}
	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 ._box-left_d9i85_34 {
	    width: 2.68rem;
	    height: 100%;
	    background-size: cover;
	    background-repeat: no-repeat
	}
	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 ._box-right_d9i85_95 ._recived-amount_d9i85_108 {
	    color: red;
	    text-shadow: 0 0 .05rem #fe0;
	    font-size: .24rem;
	    font-weight: 700;
	    margin-top: .32rem
	}
	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 ._box-right_d9i85_95 ._promote-count-bg_d9i85_127 {
	    position: absolute;
	    z-index: 2;
	    bottom: -.4rem;
	    right: 0;
	    width: 1.6rem;
	    height: .64rem;
	    background-size: 100% 100%;
	    background-repeat: no-repeat;
	    color: #fff;
	    font-weight: 700;
	    font-size: .14rem;
	    text-align: center;
	    display: flex;
	    align-items: center;
	    text-shadow: .01rem .01rem 0 #009cff;
	    justify-content: center
	}

	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 ._box-right_d9i85_95 ._promote-count-bg_d9i85_127 p {
	    max-width: 1.37rem;
	    display: -webkit-box;
	    overflow: hidden;
	    text-overflow: ellipsis;
	    vertical-align: middle;
	    -webkit-line-clamp: 2;
	    -webkit-box-orient: vertical
	}
	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 ._box-center_d9i85_40 {
	    width: 3rem;
	    height: 100%;
	    display: flex;
	    flex-direction: column;
	    align-items: center;
	    justify-content: flex-start;
	    margin-left: -.2rem
	}
	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 ._box-center_d9i85_40 ._title_d9i85_49 {
	    margin: 0 auto;
	    display: flex;
	    align-items: center;
	    min-height: .36rem;
	    justify-content: center;
	    margin-top: .08rem
	}

	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 ._box-center_d9i85_40 ._title_d9i85_49 span {
	    color: #fff;
	    font-weight: 700;
	    font-size: .15rem;
	    text-align: center;
	    max-width: 2.1rem;
	    text-shadow: .01rem .01rem 0 #009cff;
	    display: -webkit-box;
	    overflow: hidden;
	    text-overflow: ellipsis;
	    vertical-align: middle;
	    -webkit-line-clamp: 2;
	    -webkit-box-orient: vertical
	}

	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 ._box-center_d9i85_40 ._count-msg_d9i85_71 {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    flex-direction: column;
	    font-weight: 700
	}

	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 ._box-center_d9i85_40 ._count-msg_d9i85_71:not(:lang(zh)) {
	    margin-top: .04rem
	}

	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 ._box-center_d9i85_40 ._count-msg_d9i85_71 p {
	    font-size: .2rem;
	    color: #fff;
	    text-shadow: .01rem .01rem 0 #009cff;
	    overflow: hidden;
	    white-space: nowrap;
	    text-overflow: ellipsis
	}

	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 ._box-center_d9i85_40 ._count-msg_d9i85_71 p:nth-child(3) {
	    margin-top: .02rem
	}

	._hk-activities-promotion_d9i85_17 ._activities-promotion-box_d9i85_24 ._box-center_d9i85_40 ._count-msg_d9i85_71 p:nth-child(3):not(:lang(zh)) {
	    margin-top: .1rem
	}


	._tabs_14rgh_17 {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    width: calc(100% - .4rem);
	    height: .6rem;
	    margin: .03rem .2rem .15rem;
	    background-color: #fff;
	    border-radius: .14rem;
	    box-shadow: 0 0 .05rem #00d9ff
	}
	._tabs_14rgh_17 ._left_14rgh_28 {
	    display: flex;
	    justify-content: space-around;
	    align-items: center;
	    flex: 1;
	    margin-right: .15rem
	}
	._tabs_14rgh_17 ._left_14rgh_28 ._headerItem_14rgh_35 {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    width: 1.87rem;
	    height: .4rem;
	    margin-left: .2rem;
	    color: var(--skin__primary);
	    font-size: .18rem;
	    background-color: #bad7ff;
	    border-radius: .28rem
	}
	._tabs_14rgh_17 ._left_14rgh_28 ._headerItem_14rgh_35._active_14rgh_62 {
	    color: #fff;
	    font-weight: 700;
	    background-color: var(--skin__primary)
	}
	._tabs_14rgh_17 ._left_14rgh_28 ._headerIcon_14rgh_57 {
	    width: .24rem;
	    height: .24rem;
	    margin-right: .085rem
	}
	._tabs_14rgh_17 ._left_14rgh_28 ._headerItem_14rgh_35 ._name_14rgh_53 {
	    font-size: .2rem;
	    max-width: 54%
	}

	._user-info-box_mk765_17 {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    padding: 0 .2rem
	}
	._user-info-box_mk765_17 ._user-top_mk765_23 {
	    display: flex;
	    align-items: center;
	    font-size: .2rem;
	    color: var(--skin__alt_lead)
	}
	._vip-badge-box_10qr0_17 ._img_10qr0_26 {
	    width: .38rem;
	    height: .18rem
	}
._vip-badge-box_10qr0_17 {
    width: .96rem;
    height: .3rem;
    min-width: .49rem;
    max-width: inherit;
    padding: 0 .055rem 0 .045rem;
    margin-right: .1rem;
    border-radius: .3rem
}
._vip-badge-box_10qr0_17 ._level_10qr0_32 {
    font-size: .2rem;
    transform: scale(1);
    font-style: normal
}
._vip-badge-box_10qr0_17 ._level_10qr0_32 {
    margin-left: -.05rem;
    font-size: .28rem;
    font-style: italic;
    background: initial;
    font-weight: 700;
    position: relative;
    display: inline-block;
    color: transparent;
    text-shadow: 0 .01rem 0 rgba(0,0,0,.4);
    transform: scale(.6)
}

._user-info-box_mk765_17 ._user-top_mk765_23 ._title_mk765_29 {
    padding-right: .1rem
}
._user-info-box_mk765_17 ._user-top_mk765_23 ._platform-id_mk765_32 {
    margin-right: .1rem;
    font-weight: 700
}
._vip-badge-box_10qr0_17 ._level_10qr0_32:before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    text-shadow: none;
    background-image: linear-gradient(to bottom,#f7ea94,#e5b952 51%,#ce9510);
    background-size: cover;
    -webkit-background-clip: text;
    background-clip: text;
    content: attr(data-text)
}


.global-currency-info-index{
	border: solid thin var(--skin__border);
	border-radius: .2rem;
	height: .4rem;
	padding: 0 .06rem 0 .06rem;
	display: flex;
	box-sizing: border-box;
	align-items: center;
	justify-content: center;
	z-index: 1;
	position: relative;
	background-color: #fff
}
	/* // isTabsShow van-sticky van-sticky--fixed */
	.mengLisnMens{
		height: .5rem;
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;
	}
	.goDRiiBsuEuXD3W1NphN{
		width: 1rem;
		height: .36rem;
		border: none;
		border-radius: 0;
		-o-object-fit: cover;
		object-fit: cover;
	}

	.tabs .imageWrap {
		margin-left: -0.1rem;
	}

	.imageWrap_s {
		margin-left: 0.05rem;
	}
	.leftButton,.rightButton {
	    background-color: rgba(0,0,0,.1);
	    border: .01rem solid hsla(0,0%,100%,.1);
	    border-radius: .18rem;
	    color: #fff;
	    cursor: pointer;
	    height: .36rem;
	    line-height: .36rem;
	    text-align: center;
	    top: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	    -webkit-transform: translateY(-50%);
	    transform: translateY(-50%);
	    width: .36rem;
		min-width: .36rem;
	}
	.leftButton svg,.rightButton svg{
		width: .15rem;
		height: .15rem;
	}
	.tabForm-box{
		width: 100%;height: 0px;display: flex;align-items: center;
		justify-content: space-between;
		position: absolute;
		top:.55rem;
		z-index: 10;
	}
	.leftButton{
		position: absolute;
		left: 0;
		transform: translateY(-50%) rotate(180deg);
	}
	.tabs  .van-tabs__content{
		position: relative;
	}
	.rightButton{
		position: absolute;
		right: 0;
	}
	.warp-wYU5EComes{
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0.2rem 0;
	}
	.warp-card-user-login-wrap-vip-BttMM {
	    font-size: .16rem;
	    height: .24rem;
	    padding: 0 .06rem;
	    line-height: .24rem;
	    background-color: rgb(36, 178, 153);
	    color: #e5b952;
	    margin-right: .08rem;
	    border-radius: .04rem;
	    white-space: nowrap
	}
	.me-infoname{
		display: flex;
		align-items: center;
	}
	.me-infoname i {
	    font-size: .22rem;
	    font-style: normal;
	    color: var(--theme-text-color);
	    margin-right: .04rem;
	    overflow: hidden
	}
	.me-infoname .imageWrap{
		width: .32rem;
		height: .32rem;
		color: var(--theme-alt-primary);
	}
	.countTextBox {
	}
	.countTextBox .notranslate{
			color: var(--theme-secondary-color-finance);
		    font-size: .24rem;
		    text-overflow: ellipsis;
		    white-space: nowrap;
			    padding: 0 .08rem;
		    overflow: hidden;
		    text-decoration: underline
	}
	.countTextBox .xuanzhuan{
		width: .25rem !important;
		height: .25rem !important;
		color: var(--theme-alt-primary);
	}
	.SaqueDepósito{
		display: flex;
		align-items: center;
	}
	.SaqueDepósito .xuanzhuan{
		margin: 0 auto;
		width: 0.48rem !important; height: 0.48rem !important; color: var(--theme-text-color-darken);
	}
	.SaqueDepósito div{
		width: 1rem;
		display: flex;align-items: center;
		flex-wrap: wrap;
	}
	.SaqueDepósito  p{
		color: var(--theme-text-color-darken);
		line-height: 1;
		width: 100%;
		text-align: center;
		padding-top: .08rem;
		font-size: .16rem
	}
	.warp-notlogin-azGf5 {
	    width: 100%;
	    display: flex;
	    justify-content: space-between;
	    gap: .16rem;
	    overflow: hidden
	}

	.warp-notlogin-azGf5>div {
	    width: 44.5%;
	    height: .6rem;
	    flex-shrink: 0;
	    position: relative;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    color: var(--theme-primary-font-color);
	    font-size: .3rem
	}

	.warp-notlogin-azGf5>div:first-child {
	    background-color: var(--theme-primary-color);
	}

	.warp-notlogin-azGf5>div:first-child>span {
	    margin-left: .6rem
	}

	.warp-notlogin-azGf5>div:first-child:after {
	    position: absolute;
	    width: 0;
	    height: 0;
	    display: inline-block;
	    content: " ";
	    border-top: .8rem solid var(--theme-primary-color);
	    border-left: 0 solid transparent;
	    border-right: .8rem solid transparent;
	    border-bottom: 0 solid transparent;
	    right: -.68rem;
	    top: 0
	}

	.warp-notlogin-azGf5>div:last-child {
	    background-color: var(--skin__accent_1);
		  color: var(--theme-disabled-font-color);
		  box-sizing: border-box;
		  border-left: none;
	}

	.warp-notlogin-azGf5>div:last-child>span {
	    margin-right: .6rem
	}

	.warp-notlogin-azGf5>div:last-child:after {
	    position: absolute;
	    width: 0;
	    height: 0;
	    display: inline-block;
	    content: " ";
	    border-top: 0 solid transparent;
	    border-left: .8rem solid transparent;
		box-sizing: border-box;
	    border-right: 0 solid transparent;
	    border-bottom: .8rem solid var(--skin__accent_1);
	    left: -.68rem;
	    bottom: 0
	}
	.tebConTenet{
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: var(--theme-home-bg);
		font-size: .26rem;
		height: 1.2rem;
		color: var(--skin__neutral_3);
		position:sticky;
		top: -0.01rem;
		z-index: 20;
	}
	.tebConTenet .btn_zc1_jr2{
		width: .5rem;
		height: .5rem;
		display: none;
		position: absolute;
		bottom: 0;
		right: 0;
	}
	.game-tabItem-name-bQ3zy {
	    color: var(--theme-alt-neutral-2);
	    max-width: 96%;
	    line-height: .28rem;
	    font-size: .26rem;
	    overflow: hidden;
	    text-align: center;
	    text-overflow: ellipsis;
	    white-space: nowrap;
	    margin-top: .06rem
	}
	.tebConList{
		height: .9rem;
		flex: 1;
		margin-right: .15rem;
		box-sizing: border-box;
		border-radius: .14rem;
		padding: .04rem;
		text-align: center;
		font-size: .18rem;
		box-shadow: 0 0 .07rem #00d9ff;
		border: solid .01rem #bad7ff;
		background-color: #fff;
	}
	.tebConList:nth-child(3n){
		margin-right: 0;
	}
	.tebConListConem{
		display: flex;
		padding: .02rem;
		align-items: center;
		width: 82%;
		scroll-behavior: smooth;
		overflow: scroll;
	}
	.RbbrBFJf{
		width: .48rem !important;
		height: .48rem !important;
	}
	.tebConList .img{
		width: .6rem;
		height:auto;
		margin-bottom: .02rem;
	}
	.tebConList.active{
		background-image: linear-gradient(0deg, #b5feff, #fff 52%, #b1feff);
		border: .01rem solid #03c3ff;
		font-weight: 700 !important;
		color: var(--skin__primary);
	}
	.tebConList.active .btn_zc1_jr2{
		display: block;
	}
</style>

<style>
	.me3Dian7 .menPensmeConems .swiper-box {
		padding:.16rem .2rem .16rem;
	}
	.me3Dian7  #icon-sprite_icon_dt_1pmd--svgSprite2{
		opacity: 0;
		animation: fadeInOut .5s infinite 0.1s;
	}
	.me3Dian7  #icon-sprite_icon_dt_1pmd--svgSprite3{
		opacity: 0;
		animation: fadeInOut .5s infinite 0.2s;
	}
	.me3Dian7  @keyframes fadeInOut {
		0% {
			opacity: 0; /*初始状态 透明度为0*/
		}
		100% {
			opacity: 1; /*结尾状态 透明度为1*/
		}
	}
	.me3Dian7  .isTabsShow .van-sticky{
		opacity: 0;
	}
	.me3Dian7  .van-sticky.van-sticky--fixed {
		transform: initial;
		transition: .5s;
	}

	.me3Dian7  .conter_box .van-tab--disabled {
		color: #646566 !important;
		cursor:pointer;
	}
	.me3Dian7 {
		.conter_box .van-tab{
				padding: 0 !important;
			}

			.home-scrollbar .van-tab__text--ellipsis {
				-webkit-line-clamp: initial;
			}

			.home-scrollbar .van-sticky--fixed {
				z-index: 88;
			}

			.home-scrollbar {
				height: 100vh;
				/* overflow: scroll; */
			}
			.conterTeng-scrollbar{
				overflow: scroll;
			}


			.conterTeng-scrollbar::-webkit-scrollbar {
			    width: .06rem;
				height: 1rem;
				display: block;
				position: relative;
			}

			/* 自定义滚动条轨道 */
			.conterTeng-scrollbar::-webkit-scrollbar-track {
			  background:transparent; /* 设置轨道的背景颜色 */
			}

			/* 自定义滚动条的滑块（thumb） */
			.conterTeng-scrollbar::-webkit-scrollbar-thumb {
			  background: var(--theme-color-line); /* 设置滑块的背景颜色 */

			}

			/* 当滑块悬停或活动时自定义滚动条的滑块 */
			.conterTeng-scrollbar::-webkit-scrollbar-thumb:hover {
			  background: #555; /* 设置滑块在悬停状态下的背景颜色 */
			}
			.conterTeng-scrollbar {
			-ms-overflow-style:scroll; /* 针对IE、Edge浏览器 */
			scrollbar-width: none;  /*针对Firefox浏览器 */
			}

			.marquee {
				background-color: transparent;
				border-radius: 0;
				/* -webkit-box-shadow: 0 .03rem .09rem 0 transparent; */
				/* box-shadow: 0 .03rem .09rem 0 transparent; */
				font-size: .24rem !important;
				padding: 0 .2rem 0 .25rem;
				-ms-flex-align: center;
				-ms-flex-pack: justify;
				align-items: center;
				justify-content: center;
				background-color: transparent !important;
				border-radius: .1rem;
				/* -webkit-box-shadow: 0 .03rem .09rem 0 rgba(0, 0, 0, .06); */
				/* box-shadow: 0 .03rem .09rem 0 rgba(0, 0, 0, .06); */
				color: var(--theme-text-color) !important;
				display: -ms-flexbox;
				display: flex;
				justify-content: space-between;
				width: 80%;
				padding: 0 !important;
			}

			.van-hairline--bottom::after {
				border: none !important;
			}

			.marquee .van-icon {
				display: flex;
				justify-content: center;
				align-content: center;
				margin-right: 5px;
			}
			.notice-barCome{
				/* padding: .06rem .2rem !important; */
				box-sizing: border-box;
				font-weight: 700;
			}
			.notice-bar {
				display: flex;
				width: 100%;
				display: block;
				align-items: center;
				justify-content: space-between;
				box-sizing: border-box;
				height: .7rem;
				margin: 0 auto;
				/* box-shadow: 0 0 .1rem 0 var(--theme-primary-color)!important; */
				    border-radius: .1rem;
				    /* padding: 0 .04rem; */
					background-size: 100% 100%;
					padding: 0 !important;
				 cursor: pointer;
			}
			.notice-bar .van-icon{
				display: none;
				margin-right: .2rem;
			}

			.zhtDEqmqr6aOwFvu_UTp {
				margin: 0 .2rem;
				align-items: center;
				display: -ms-flexbox;
				display: flex;
				-ms-flex-direction: column;
				flex-direction: column;
				justify-content: center;
			}

			._VQdc8vOEOzzyOEUKmvZ {
				cursor: pointer;
				height: var(--jackpot-card-height);
				margin: var(--jackpot-card-margin);
				position: relative;
				width: var(--jackpot-card-width);
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.defaultValue {
				justify-content: center;
			}

			.tabs {
				height: 100%;
			}

			.vwuYKuCNAmUF0GsyJhVu {
				padding: 0 0.2rem;
			}

			.gameItemBox {
				display: flex;
				-ms-flex-wrap: wrap;
				flex-wrap: wrap;
				height: 100%;
			}

			.scroll-container {
				height: 100%;
				overflow: auto;
			}

			.tabs .van-tab {
				line-height: normal;
			}

			.tabs .van-tabs--line .van-tabs__wrap {
				height: auto !important;
			}

			.tabs .van-tabs .van-tabs__nav {
				background-color: var(--cms-background-color-primary);
				border-bottom: .01rem solid var(--theme-color-line);
				height: 1.06rem;
				padding: .08rem 0 0;
			}


			.tabs .van-tabs__line {
				background-color: var(--cms-primary-color);
				border-radius: .04rem .04rem 0 0;
				height: .04rem;
				min-width: 1.5rem;
				bottom: 0;
			}

			.tabs .van-tab--active .h5MidMenuTab {
				color: var(--cms-primary-color) !important;
			}

			.tabs .cover {
				background: transparent !important;
			}

			.tabs .imageWrap {
				height: .46rem !important;
				width: .6rem !important;
			}

			.h5MidMenuTab {
				min-width: 1.5rem;
				position: relative;
				text-align: center;
				z-index: 2;
				color: var(--cms-text-color-secondary);
			}

			.h5MidMenuTab-conter{
				color: var(--cms-primary-color);
			}

			.game-category-name {
				line-height: 1.5;
				max-width: 1.36rem;
				width: 1.36rem !important;
			}

			.leftTitle {
				-ms-flex-align: center;
				align-items: center;
				color: var(--cms-text-color-primary);
				display: -ms-flexbox;
				display: flex;
				font-size: .3rem;
			}

			.kQtvRRirB33JTKwlSb26 {
				-ms-flex-align: center;
				-ms-flex-pack: justify;
				align-items: center;
				display: -ms-flexbox;
				display: flex;
				justify-content: space-between;
				padding: .3rem 0;
			}

			.bkAYznjEc9hUqGQh_a3S {
				display: block;
				font-size: .24rem;
				text-align: center;
				color: var(--cms-text-color-secondary);
				margin-top: .1rem;
				margin-bottom: 0.2rem;
			}

			.WGAruokZzpTWkHI2SQ9G {
				color: var(--cms-global-spare-color);
				display: block;
				font-size: .24rem;
				margin-top: .03rem;
			}

			.LseXQWJMvDiV2XalL3sA {
				padding: .4rem .2rem;
				position: relative;
				width: 100%;
				background-color: var(--skin__web_bs_yj_bg);
				z-index: 1;
				box-sizing: border-box;
				padding-bottom: 0.5rem;
			}

			.UJY0E549iXw8BAops2og {
				-ms-flex: 1;
				flex: 1;
				overflow: hidden
			}

			.vertival-box {
				margin-bottom: .4rem;
				padding-bottom: 0rem;
				/* position: relative */
			}

			.vertival-box>div {
				padding-right: .2rem
			}

			.UJY0E549iXw8BAops2og .JxE2bCrlce_jVHNQ56UL {
				color: var(--theme-text-color);
				font-size: .24rem;
				margin-bottom: .12rem
			}

			.TxOZ1v6RrtK6SNKSEukb .vertival-box {
				margin-bottom: .4rem;
				padding-bottom: .48rem;
				position: relative
			}

			.bUGFPYZ0IBtUg6TvqFnc {
				display: -ms-flexbox;
				display: flex;
			}

			.link-list-title {
				color: var(--theme-text-color);

				margin-bottom: .2rem
			}

			.vertival-box:after {
				background-color: var(--theme-colorxxx-line);
				bottom: 0;
				content: "";
				height: .01rem;
				left: 50%;
				position: absolute;
				-webkit-transform: translateX(-50%);
				transform: translateX(-50%);
				width: 100%;
			}

			.UJY0E549iXw8BAops2og .dIvaBEC9yHdlaEHxlYwe .m4LhLKEZzJw_JjBFp0PP {
				color: var(--theme-text-color);
				cursor: pointer;
				font-size: .24rem !important;
				margin-bottom: .1rem;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap
			}

			.company-info {
				padding-bottom: .4rem;
				position: relative;
				    text-align: center;
			}

			.contactus-box {
				padding-bottom: .4rem;
				margin-bottom: .4rem;
		    	border-bottom: .02rem solid var(--theme-color-line);
			}

			.dX6cyFScnFIBaOgvBaOs {
				color: var(--cms-text-color-secondary);
				font-size: .24rem;
				font-weight: 400;
				margin-bottom: .2rem
			}

			.ZRKW0CIFYaJACLzrm8Rh {
				box-sizing: border-box;
				height: .7rem;
				display: flex;
			}

			.M5NoRqtHOQuocfpNLEaP {
				-ms-flex-align: center;
				align-items: center;
				display: -ms-flexbox;
				display: flex;
				-ms-flex-wrap: wrap;
				flex-wrap: wrap;
				box-sizing: border-box;
				gap: .2rem;
				max-width: fit-content;
				margin-left: auto;
				margin-right: auto;
			}

			.company-info:after {
				background-color: var(--theme-color-line);
				bottom: 0;
				content: "";
				height: .015rem;
				left: 50%;
				position: absolute;
				-webkit-transform: translateX(-50%);
				transform: translateX(-50%);
				width: 100%
			}

			.company-info {
				color: var(--theme-text-color-lighten);
				font-size: .2rem;
				line-height: 1.66;
				word-break: break-all
			}

			.company-info2 {
				width: 6.7rem;
    			margin: .2rem auto 0;
				position: relative;
				text-align: center;
				color: var(--theme-text-color-lighten);
				font-size: .22rem;
				line-height: 1.66;
			}

			.TNhhMltbvlGJmWgLd9F5 {
				-ms-flex-pack: center;
				display: -ms-flexbox;
				display: flex;
				-ms-flex-wrap: wrap;
				flex-wrap: wrap;
				gap: .1rem;
				justify-content: center;
				margin-top: .4rem
			}

			.copy-right {
				padding-top: .4rem
			}

			/* .ZvyDsn48oSuCoga63jmJ ul {
		    -ms-flex-align: center;
		    align-items: center;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		    width: 100%
		} */
			.ZvyDsn48oSuCoga63jmJ {
				-ms-flex-pack: center;
				display: -ms-flexbox;
				display: flex;
				justify-content: center;
				width: 100%
			}

			.ZvyDsn48oSuCoga63jmJ ul {
				-ms-flex-pack: center;
				display: -ms-flexbox;
				display: flex;
				justify-content: center;
				margin: 0 !important;
				width: 100%
			}

			.ZvyDsn48oSuCoga63jmJ ul li {
				border-right: .025rem solid var(--theme-color-line);
				color: var(--theme-text-color-lighten);
				font-size: .16rem;
				line-height: 1.2;
				overflow: hidden;
				padding: 0 .32rem;
				text-overflow: ellipsis;
				white-space: nowrap
			}

			.ZvyDsn48oSuCoga63jmJ ul li:last-child {
				border-right: 0
			}
			.svg-icon_pmd{
				position: absolute;
				left: 0;
			}
			.N4LsWhJBhqqyTkv6V0NE {}


	}

</style>
